import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { FatalErrorService } from '../services/fatal-error.service';

export const fatalGuard: CanActivateFn = () => {
  const fatal = inject(FatalErrorService);
  const router = inject(Router);
  return fatal.active ? router.parseUrl('/error') : true;
};



